import React from "react"
import Modal from "react-bootstrap/Modal"
import CategoryList from "../../CategoryList"

import "../Styles/modal_transition.scss"
import "../../../../styles/layouts"

const Category = (props) => {
  return (
    <React.Fragment>
      <Modal className="half-modal" show={props.show} onHide={props.onHide}>
        <Modal.Body>
          <CategoryList layered={true} onChange={props.onChange} {...props} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  )
}

export default Category
